import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const useBuscaTextoPadraoSpf = ({ formik }) => {
  const [textoPadrao, setTextoPadrao] = useState("");
  const { request: requestTextoPadraoSpf, data: dataTextoPadraoSpf, errors, isLoading } = useApiClient();

  const { values } = formik;

  useEffect(() => {
    if (values?.sequencialTipoAcao !== null && values?.sequencialTipoAcao !== "") {
      const parametros = { sqTipoAcaoFiscal: values?.sequencialTipoAcao };
      requestTextoPadraoSpf(apiRoutes.fiscalizacao.procedimentoFiscal.buscatextopadraospf, parametros);
    }
  }, [requestTextoPadraoSpf, values?.sequencialTipoAcao]);

  useEffect(() => {
    if (dataTextoPadraoSpf) {
      setTextoPadrao(dataTextoPadraoSpf.result);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [dataTextoPadraoSpf, errors]);

  if (isLoading) {
    return (
      <span>
        <Spinner animation="border" role="status" />
        Carregando Texto Padrão da Spf...
      </span>
    );
  }

  return { textoPadrao };
};

export default useBuscaTextoPadraoSpf;
